// External Dependencies
import { useLocation } from 'react-router-dom';

// Internal Dependencies
import DataGridContainer from 'components/shared/TableDataGrid/DataGridContainer';
import TableDataGridServerSide, {
  useParsedDataGridQueryString,
} from 'components/shared/TableDataGrid/ServerSide';
import { useGetAllEstimates } from 'hooks/api/estimates';
import TableDataGridZeroResultsState from 'components/shared/TableDataGrid/TableDataGridZeroResultsState';
import { Subtitle } from 'components/shared';

// Local Dependencies
import { useColumns } from './hooks';

// Local Variables
const handleTableClickRow = (id: string) => `/estimates/${id}`;

// Component Definition
const EstimatesTable = () => {
  const { search } = useLocation();

  const columns = useColumns();

  const {
    filters,
    pagination,
    sort,
  } = useParsedDataGridQueryString(search, {
    columns,
    mapAllKeysToSnakeCase: false,
  });

  const {
    data: districtEstimatesData,
    isLoading,
  } = useGetAllEstimates({
    filters,
    limit: pagination?.pageSize ?? 100,
    page: pagination?.page ?? 1,
    sort,
  });

  return (
    <>
      <Subtitle>Estimates</Subtitle>
      <DataGridContainer>
        <TableDataGridServerSide
          clickRowTo={handleTableClickRow}
          columns={columns}
          components={{
            NoRowsOverlay: TableDataGridZeroResultsState,
          }}
          fullCount={districtEstimatesData?.data.fullCount ?? 0}
          loading={isLoading}
          rows={districtEstimatesData?.data.data ?? null}
          tableResource="estimates"
          withSearch
          zeroStateMessage="No estimates found."
        />
      </DataGridContainer>
    </>
  );
};

export default EstimatesTable;
